import { render, staticRenderFns } from "./budgets.vue?vue&type=template&id=1fdbc099&scoped=true&"
import script from "./budgets.vue?vue&type=script&lang=js&"
export * from "./budgets.vue?vue&type=script&lang=js&"
import style0 from "./budgets.vue?vue&type=style&index=0&id=1fdbc099&prod&scoped=true&lang=css&"
import style1 from "./budgets.vue?vue&type=style&index=1&id=1fdbc099&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdbc099",
  null
  
)

export default component.exports